export function validate(state) {
  const errors = [
    required(state.to, '宛先'),
    required(state.message, 'メッセージ')
  ]

  if (state.interval === 'day') {
    // なし
  } else if (state.interval === 'week') {
    // 週間
    const weeks = state.weeks
    const hasWeek = Object.keys(weeks).some(key => weeks[key])
    if (!hasWeek) {
      errors.push('曜日は１つ以上選択してください')
    }
  } else if (state.interval === 'otherWeek') {
    // 隔週
    const weeks = state.weeks
    const hasWeek = Object.keys(weeks).some(key => weeks[key])
    if (!hasWeek) {
      errors.push('曜日を１つ選択してください')
    }
  } else if (state.interval === 'month') {
    // 日が必須
    errors.push(numberValidate(state.day, 31, '日'))
  } else if (state.interval === 'year') {
    // 月と日が必須
    errors.push(numberValidate(state.month, 12, '月'))
    errors.push(numberValidate(state.day, 31, '日'))
  }

  errors.push(timeValidate(state.time.hour, state.time.minute))

  return errors.filter(v => v)
}

function required(value, label) {
  if (!value) {
    return `${label}は入力必須です`
  }
  return null
}

export function numberValidate(value, maxLength, label) {
  const requiredError = required(value, label)
  if (requiredError) {
    return requiredError
  } else if (value <= 0 || maxLength < value) {
    return `${label}を正しく入力してください`
  }
  return null
}

export function timeValidate(hour, minute) {
  if (hour === '' || minute === '') {
    return '時間は入力必須です'
  } else if (hour < 0 || hour > 12) {
    return '時間を正しく入力してください'
  } else if (minute < 0 || minute > 59) {
    return '時間を正しく入力してください'
  }
  return null
}
